import React, { PropsWithChildren, useEffect } from 'react';
import { connect } from 'react-redux';
import { platformSuperAdminSelectors } from '../../../../state/ducks/platformSuperAdmin/selectors';
import { RootState } from '../../../../state/store/store';
import Loader from '../../../shared/SmallComponents/Loader';
import ExceptionPage from '../../ExceptionPage/ExceptionPage';

type Props = PropsWithChildren<{
    accessChecked: boolean;
    isPlatformSuperAdmin: boolean;
    confirmAccess: () => void;
}>;

const PlatformGuard = ({ accessChecked, isPlatformSuperAdmin, confirmAccess, children }: Props) => {
    useEffect(() => {
        confirmAccess();
    }, [confirmAccess]);

    if (!accessChecked) return <Loader />;
    if (!isPlatformSuperAdmin) {
        return (
            <ExceptionPage
                status={403}
                title="Access Denied"
                subTitle="Platform super admin access is required for this area."
            />
        );
    }
    return <>{children}</>;
};

export default connect(
    (state: RootState) => ({
        accessChecked: platformSuperAdminSelectors.accessChecked(state),
        isPlatformSuperAdmin: platformSuperAdminSelectors.isPlatformSuperAdmin(state)
    }),
    (dispatch: any) => ({
        confirmAccess: () => dispatch.platformSuperAdmin.confirmAccess()
    })
)(PlatformGuard);
